import React from 'react';

const PhoneNumber = ({ phoneNumber }) => {
  if (!phoneNumber) return null;
  const formattedPhoneNumber = phoneNumber
    .replace(/\D+/g, '')
    .replace(/^(\d{0,3})(\d{0,3})?(\d{0,4})?$/, (match, p1, p2, p3) => {
      let result = '';
      if (p1) result += p1 + (p2 ? ' ' : '');
      if (p2) result += p2 + (p3 ? ' ' : '');
      if (p3) result += p3;
      return result;
    });

  return <>{formattedPhoneNumber}</>;
};

export default PhoneNumber;
